import { useSyncExternalStore } from 'react';
import { entityProjection } from '../entity-projection';
import type { WorkspaceDoc } from '../entity-types';

const EMPTY: readonly WorkspaceDoc[] = Object.freeze([]);

export function useWorkspaceDocs(): readonly WorkspaceDoc[] {
  return useSyncExternalStore(
    (l) => entityProjection.subscribe(l),
    () => entityProjection.getSnapshot().docs,
    () => EMPTY,
  );
}
